export default {
  install (Vue) {
    Vue.prototype.$eventBus = new Vue({
      methods: {
        emit (event, ...args) {
          this.$emit(event, ...args)
        },
        on (event, callback) {
          this.$on(event, callback)
        },
        off (event, callback) {
          this.$off(event, callback)
        }
      }
    })
  }
}
